import { render } from "./projectDetail.vue?vue&type=template&id=2ea3a7f4&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"

import "./projectDetail.vue?vue&type=style&index=0&id=2ea3a7f4&lang=scss&scoped=true"
import "./projectDetail.vue?vue&type=style&index=1&id=2ea3a7f4&lang=css"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea3a7f4"]])

export default __exports__